export default __webpack_public_path__ + "static/media/in-review-request.c50b64a1.svg";